<a
  [routerLink]="item?.itemUrl"
  role=""
  class="masonry-card d-block mb-4 text-dark text-decoration-none overflow-hidden"
  wlAutomationId="masonry-card"
>
  @if (item?.imageUrl) {
    <img
      [defaultImage]="'assets/image-placeholder.png' | deployUrl"
      [lazyLoad]="item?.imageUrl"
      [attr.alt]="item?.title"
      [attr.data-src]="item?.imageUrl"
      offset="100"
      class="masonry-card__image img-fluid w-100"
    />
  }
  <div class="p-2 pt-3">
    <h2 class="h4 text-brand hyphenate" wlAutomationId="masonry-card-title">
      {{ item?.title }}
    </h2>
    <p>{{ item?.caption }}</p>
  </div>
</a>
